import '|/app.styl';

// Scripts

// Vendors
import Parallax from './Vendor/Parallax';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Masonry Grid
        $('.meetings-results.grid').masonry();

        // Run our vendor scripts
        new Parallax();

    });

})(jQuery);